import { APP_ENV, APP_ENVS, FARO_APP_NAME, FARO_URL } from '@/constants/env'

export const initializeFaroClient = async () => {
  const shouldInitialize =
    globalThis.window !== undefined &&
    FARO_URL &&
    FARO_APP_NAME &&
    APP_ENV === APP_ENVS.PRODUCTION

  if (!shouldInitialize) return

  const [{ faro, getWebInstrumentations, initializeFaro }, { TracingInstrumentation }] =
    await Promise.all([
      import('@grafana/faro-web-sdk'),
      import('@grafana/faro-web-tracing'),
    ])

  if (faro.api) return

  initializeFaro({
    url: FARO_URL,
    app: {
      name: FARO_APP_NAME,
      environment: APP_ENVS.PRODUCTION,
      version: '1.0.0',
    },
    instrumentations: [...getWebInstrumentations(), new TracingInstrumentation()],
  })
}
